/**
 * Created by Josef Jurca on 30/08/2017.
 */

class PaymentGateway {

    /**
     * Constructs the model.
     *
     * @param {Object} data - Payment gateway entry data.
     * @returns {PaymentGateway} Payment gateway item.
     */
    constructor (data) {

        this.id = data.id || null;
        this.isDefault = data.isDefault || false;
        this.name = data.name || '';
        this.selectedBy = data.selectedBy || '';

        return this;
    }

    /**
     * I payment is default, returns true.
     *
     * @returns {PaymentGateway.isDefault} Returns tru if is default.
     */
    isDefaultGateway () {
        return this.isDefault;
    }
}

export default PaymentGateway;


// WEBPACK FOOTER //
// ./src/js/models/paymentgateway.js